import { useEffect, useRef, useState } from 'react';
import cx from 'classnames';

import boxSrc from '../../assets/images/game/box.webp';
import boxSrc2x from '../../assets/images/game/box@2x.webp';

import styles from '../../styles/modules/game/Game.module.scss';

import { useGameStore } from '../../store/useGameStore';
import { useConfigStore } from '../../store/useConfigStore';

import Modal from '../modal/Modal';

const BELT_SPEED = 0.06;

const GameBox = ({ id, onRemoveBox, feedIdx }) => {
	const [isOpened, setIsOpened] = useState(false);
	const [isFalling, setFalling] = useState(false);

	const boxRef = useRef(null);
	const openedRef = useRef(false);

	const { switchAnimation } = useGameStore();
	const { openModal } = useConfigStore((s) => s);

	useEffect(() => {
		const boxElement = boxRef.current;

		if (!boxElement) return;

		let progress = -70;
		let lastTime = performance.now();
		let frameId = 0;

		const animate = (time) => {
			progress += Math.min(time - lastTime, 50) * BELT_SPEED;
			lastTime = time;

			boxElement.style.top = `${progress}px`;

			const beltEnd = (boxElement.parentElement?.offsetHeight ?? 0) - boxElement.offsetHeight;

			if (progress >= beltEnd) {
				setFalling(true);

				return;
			}

			frameId = requestAnimationFrame(animate);
		};

		frameId = requestAnimationFrame(animate);

		return () => {
			cancelAnimationFrame(frameId);
		};
	}, []);

	const openBoxHandler = () => {
		if (openedRef.current) return;

		openedRef.current = true;
		setIsOpened(true);

		openModal(Modal);
		switchAnimation(feedIdx);

		window.setTimeout(() => {
			onRemoveBox(id);
		}, 220);
	};

	return (
		<div
			ref={boxRef}
			className={cx(styles.box, { [styles.selected]: isOpened, [styles.falling]: isFalling })}
			onClick={openBoxHandler}
			style={{ position: 'absolute' }}
		>
			<img
				src={boxSrc}
				srcSet={`${boxSrc} 1x, ${boxSrc2x} 2x`}
				alt=''
				className={cx(styles['box-image'], { [styles.hidden]: isOpened })}
				onAnimationEnd={() => onRemoveBox(id)}
			/>
		</div>
	);
};

export default GameBox;
